/* Herbal Talents - Rabattcode im Warenkorb (Shopify Ajax Cart API: POST /cart/update.js mit { discount }) */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MSG_KEY = 'ht-discount-msg';

  function currentCodes(box) {
    return (box.getAttribute('data-codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  }
  function updateCart(codes) {
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }
  function isApplied(cart, code) {
    var c = code.toUpperCase();
    if (Array.isArray(cart.discount_codes)) {
      var hit = cart.discount_codes.filter(function (d) { return String(d.code).toUpperCase() === c; })[0];
      if (hit) return hit.applicable !== false;
    }
    var titles = [];
    (cart.cart_level_discount_applications || []).forEach(function (a) { titles.push(a.title); });
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (al) {
        if (al.discount_application) titles.push(al.discount_application.title);
      });
    });
    return titles.some(function (t) { return String(t).toUpperCase() === c; });
  }
  function setMsg(text, ok) {
    document.querySelectorAll('[data-ht-discount-msg]').forEach(function (el) {
      el.textContent = text; el.classList.toggle('is-ok', !!ok);
    });
  }
  function refresh(text, ok) {
    var drawer = document.querySelector('#CartDrawer');
    var onCartPage = /\/cart\/?$/.test(location.pathname);
    if (!drawer || onCartPage) {
      try { sessionStorage.setItem(MSG_KEY, JSON.stringify({ text: text, ok: ok })); } catch (e) {}
      location.reload();
      return;
    }
    fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var fresh = sections['cart-drawer'] && parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          var host = drawer.closest('cart-drawer');
          if (overlay && host && host.close) overlay.addEventListener('click', host.close.bind(host));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        var b = sections['cart-icon-bubble'] && parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (bubble && b) bubble.innerHTML = b.innerHTML;
        setMsg(text, ok);
      })
      .catch(function () { location.reload(); });
  }
  function apply(box) {
    var input = box.querySelector('[data-ht-discount-input]');
    var btn = box.querySelector('[data-ht-discount-apply]');
    var code = (input.value || '').trim().toUpperCase();
    if (!code) { setMsg('Bitte gib einen Code ein.'); input.focus(); return; }
    var before = currentCodes(box);
    if (before.map(function (c) { return c.toUpperCase(); }).indexOf(code) > -1) { setMsg('Der Code ' + code + ' ist bereits eingelöst.', true); return; }
    btn.setAttribute('aria-busy', 'true');
    updateCart(before.concat(code)).then(function (cart) {
      if (isApplied(cart, code)) { refresh('Code ' + code + ' eingelöst.', true); return; }
      return updateCart(before).then(function () {
        btn.removeAttribute('aria-busy');
        setMsg('Der Code ' + code + ' ist nicht gültig oder passt nicht zu den Artikeln im Warenkorb.');
      });
    }).catch(function () { btn.removeAttribute('aria-busy'); setMsg('Das hat nicht geklappt. Bitte versuch es noch einmal.'); });
  }
  function remove(box, code) {
    var rest = currentCodes(box).filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
    updateCart(rest).then(function () { refresh('Code ' + code + ' entfernt.', true); })
      .catch(function () { setMsg('Das hat nicht geklappt. Bitte versuch es noch einmal.'); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ht-discount-apply]');
    var r = e.target.closest('[data-ht-discount-remove]');
    if (a) { e.preventDefault(); apply(a.closest('[data-ht-discount]')); }
    if (r) { e.preventDefault(); remove(r.closest('[data-ht-discount]'), r.getAttribute('data-ht-discount-remove')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-ht-discount-input]')) { e.preventDefault(); apply(e.target.closest('[data-ht-discount]')); }
  });
  document.addEventListener('DOMContentLoaded', function () {
    try { var s = JSON.parse(sessionStorage.getItem(MSG_KEY) || 'null'); if (s) { setMsg(s.text, s.ok); sessionStorage.removeItem(MSG_KEY); } } catch (e) {}
  });
})();
